import Icon from 'molecules/Icon';
import Link from 'molecules/Link';
import styles from 'molecules/TheDownloader/download.module.scss';

import type { DownloadProps } from 'molecules/TheDownloader/config';
import type { FC } from 'react';

const TheDownloader: FC<DownloadProps> = ({ heading, label, url }) => (
  <div className={styles.container}>
    {heading && <p className={styles.heading}>{heading}</p>}
    {(label || url) && (
      <Link className={styles.link} href={url || ''}>
        {label || 'Download'}
        <Icon icon="arrow-right" size={14} />
      </Link>
    )}
  </div>
);

export default TheDownloader;
